import React, { useContext } from 'react';
import styles from './StatusChip.module.scss';

import { ReportStatusValue } from '../../../Models/ReportValue';
import { SFChip, SFGreen, SFRed, SFThemeType } from 'sfui';
import { AppearanceContext } from 'ui-smartforce-settings';

const getChipColor = (
  status: ReportStatusValue,
  themeType: SFThemeType
): string => {
  switch (status) {
    case 'Completed':
      return themeType === 'day' ? SFGreen[500] : SFGreen[200];
    case 'Missing Information':
      return themeType === 'day' ? SFRed[700] : SFRed[200];
    default:
      return 'default';
  }
};

const getChipLabel = (status: ReportStatusValue): string => {
  switch (status) {
    case 'Missing Information':
      return 'Missing information';
    default:
      return status;
  }
};

export interface StatusChipProps {
  isReportable?: boolean;
  status?: ReportStatusValue;
  size?: 'small' | 'tiny';
}

export const StatusChip = ({
  isReportable = true,
  status = 'Completed',
  size = 'small'
}: StatusChipProps): React.ReactElement<StatusChipProps> => {
  const { themeType } = useContext(AppearanceContext);
  const chipStatus = status ?? 'Completed';
  const color = isReportable ? getChipColor(chipStatus, themeType) : 'default';
  const label = isReportable ? getChipLabel(chipStatus) : 'Draft';
  const statusClassNames = {
    Completed: styles.completed,
    'Missing Information': styles.missing_information,
    Archived: ''
  };
  const statusClassName = isReportable ? statusClassNames[chipStatus] : '';

  return (
    <SFChip
      sfColor={color}
      variant="outlined"
      size={size}
      label={label}
      className={`${styles.statusChip} ${statusClassName}`}
    />
  );
};
